/**
 * @deprecated
 * These is the old site branding
 */
export const BRAND_COLOR = {
  50: "#fef8ee",
  100: "#fcefd8",
  200: "#f7dab1",
  300: "#f2bf7f",
  400: "#eb9b4c",
  500: "#e88635",
  600: "#d8661e",
  700: "#b34e1b",
  800: "#8f3f1d",
  900: "#73351b",
};
